import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'whatwg-fetch';
import cx from 'classnames';
import Recaptcha from 'react-recaptcha';
import { TextField, Checkbox, Button, ButtonProps, ButtonType } from '@riotgames/accounts-react-components';
import AppContext from '../AppContext';
import { isIngameMobile, getThemeClassName, SectionType } from '@riotgames/accounts-react-components/lib/Theme';
import { Grid, GridAlignment, GridDirection, GridJustify } from '@riotgames/accounts-react-components/lib/Grid';
import { GridPage } from '@riotgames/accounts-react-components/lib/Grid/GridPage';
import { GridPanel } from '@riotgames/accounts-react-components/lib/Grid/GridPanel';

class SampleGrid extends Component {
  static contextType = AppContext;

  render() {
    const {
      state: { theme, footer, contentFooter }
    } = this.context;

    return (
      <GridPage
        title={'Create a Riot account'}
        footer={footer}
        contentFooter={contentFooter}
        page={0}
        pageCount={3}
        className={cx(getThemeClassName({ ...theme, section: SectionType.signup }))}
      >
        <GridPanel
          title={'What’s your email?'}
          subTitle={isIngameMobile(theme) ? null : 'Used for login to all games.'}
          links={[
            <a
              href={'#'}
              key={1}
              onClick={(e) => {
                e.preventDefault();
                linkTo('Views|Sign In')();
              }}
            >
              Sign in to existing account
            </a>
          ]}
          button={<Button label={'Create'} buttonType={ButtonType.submit} onClick={() => linkTo(view, step2)()} />}
        >
          <Grid
            direction={GridDirection.vertical}
            align={GridAlignment.center}
            justify={GridJustify.spaceBetween}
            fill={true}
          >
            <Grid fill={true}>
              <Checkbox
                onCheckedChange={(value) => onValueChange('tos', String(value))}
                labelComponent={
                  <>
                    I agree to the <a href="#">Terms of Service</a> and have read and acknowledge the{' '}
                    <a href="#">Privacy Policy</a>
                  </>
                }
              />
              <Checkbox
                onCheckedChange={(value) => onValueChange('newsletter', String(value))}
                labelComponent={<>Receive occasional news and special offers from Riot Games</>}
              />
            </Grid>
          </Grid>
        </GridPanel>
      </GridPage>
    );
  }
}

export default SampleGrid;
